export default "__VITE_ASSET__DhzxL70K__"